import { useContext, useState } from 'react'
import currency from 'currency.js'

import BrandingContext from '../../../context/BrandingContext'
import Button from '../../../components/Button'
import ModalNewCreditPackage from './ModalNewCreditPackage'
import ModalEditCreditPackage from './ModalEditCreditPackage'
import ModalDeleteCreditPackage from './ModalDeleteCreditPackage'

const CheckoutCreditPackages = () => {
  const [branding, setBranding] = useContext(BrandingContext)
  const [newModalOpen, setNewModalOpen] = useState(false)
  const [editPackageId, setEditPackageId] = useState(null)
  const [deletePackageId, setDeletePackageId] = useState(null)

  const handleSuccess = (creditPackages) => {
    setBranding({
      ...branding,
      stripe: {
        ...branding.stripe,
        creditPackages,
      },
    })
    setNewModalOpen(false)
    setEditPackageId(null)
    setDeletePackageId(null)
  }

  return (
    <>
      <div className="border-b border-gray-200 px-6 pt-8 pb-12 space-y-4 sm:space-y-0 sm:flex sm:space-x-8 sm:items-start">
        <div className="max-w-sm flex-1">
          <h2 className="text-lg font-semibold tracking-tight mb-2">
            Default credit packages
          </h2>
          <div className="text-gray-600 text-sm space-y-2 max-w-prose">
            <p>
              Default credit packages get assigned to every subdealer in your
              account. You can set custom credit packages for each subdealer in
              the subdealer menu directly. Note that creating a custom credit
              package for a subdealer will prevent that subdealer from receiving
              any updates made to the default credit packages.
            </p>
          </div>
        </div>
        <div className="flex-1">
          {branding.stripe.creditPackages.length === 0 ? (
            <>
              <div className="mb-2 bg-gray-50 border border-gray-100 rounded-md px-4 py-3">
                <p className="text-gray-600 text-sm">
                  No default credit packages have been created
                </p>
              </div>
              <Button
                color="primary"
                className="mt-4"
                onClick={() => setNewModalOpen(true)}
              >
                Add credit package
              </Button>
            </>
          ) : (
            <div className="space-y-2">
              {branding.stripe.creditPackages.map((creditPackage) => (
                <div
                  className="flex justify-between rounded-md bg-gray-100 px-4 py-3"
                  key={creditPackage.name}
                >
                  <div className="flex-1">
                    <h3 className="text-gray-900 font-medium text-sm">
                      {creditPackage.name}
                    </h3>
                    <p className="text-sm text-gray-700">
                      Total: £{currency(creditPackage.cost / 100).format()}{' '}
                      &middot; Price per file: £
                      {currency(creditPackage.cost / 100)
                        .divide(creditPackage.credits)
                        .format()}
                    </p>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Button
                      color="white"
                      size="xs"
                      onClick={() => setDeletePackageId(creditPackage.id)}
                    >
                      Delete
                    </Button>
                    <Button
                      color="white"
                      size="xs"
                      onClick={() => setEditPackageId(creditPackage.id)}
                    >
                      Edit
                    </Button>
                  </div>
                </div>
              ))}
              <div>
                <Button
                  className="mt-2"
                  color="primary"
                  onClick={() => setNewModalOpen(true)}
                >
                  Add credit package
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      <ModalNewCreditPackage
        isOpen={newModalOpen}
        setIsOpen={setNewModalOpen}
        onSuccess={handleSuccess}
      />
      <ModalEditCreditPackage
        isOpen={!!editPackageId}
        setIsOpen={setEditPackageId}
        onSuccess={handleSuccess}
        creditPackage={
          editPackageId &&
          branding.stripe.creditPackages.find((x) => x.id === editPackageId)
        }
      />
      <ModalDeleteCreditPackage
        isOpen={!!deletePackageId}
        setIsOpen={setDeletePackageId}
        onSuccess={handleSuccess}
        creditPackage={
          deletePackageId &&
          branding.stripe.creditPackages.find((x) => x.id === deletePackageId)
        }
      />
    </>
  )
}

export default CheckoutCreditPackages
